import store from '../../../store'
import { createSelector } from 'reselect'
import { buscar } from './actions'


export const getPerfilUser = state => {
    return state.PerfilUserReducer.rPerfil.obj
}

export const selectorPerfilUser = createSelector(
    [getPerfilUser], (perfil) => {
        return perfil
    }
)
export const getPerfilUserAtual = () => {
    buscar()(store.dispatch);
    return selectorPerfilUser(store.getState());
}

export const getPerfilUserAtualSomente = () => {

    return selectorPerfilUser(store.getState());
}



// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/selector.js